<template>
    <section class="Section" style="min-height:600px;">
        <div class="Container">
            <div class="BoxWide">
                <div class="Bookmark"><span>Interventi Assegnati</span></div>
            </div>
            <FiltroInterventi :showStatoFilter="false" @FiltraInterventi="this.filtraInterventi($event)" @RimuoviFiltri="this.rimuoviFiltri"></FiltroInterventi>
        </div>
        <div class="Container Counter">            
            <GrigliaInterventi :listaInterventi="this.listaInterventi"></GrigliaInterventi>           
        </div>
    </section>
</template>

<script>

import GrigliaInterventi from "@/components/GrigliaInterventi.vue";
import FiltroInterventi from "@/components/FiltroInterventi.vue";
import {apiMixin, interventiMixin} from "/mixin.js";
import Intervento from "@/models/intervento.model.js"

export default {
    name: "InterventiAssegnati",
    components: {
        GrigliaInterventi,
        FiltroInterventi
    },
    mixins: [apiMixin, interventiMixin],   
    mounted: function(){

        this.doApiCall("get", "interventi/GetInterventiAssegnati", this.$store.getters.getUtente.Token).then(

            (data) => {                
                if(data){
                    this.listaInterventi = data.map(o => {
                        return Object.assign(new Intervento(), o)
                    });
                    this.listaInterventiOriginale = this.listaInterventi;
                }
            }
        );
    }

}
</script>